<template>
  <div id="app">

      <router-view/>

  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  watch: {},
  created() {

  },
  mounted() {
    if (this._isMobile()) {
      // 手机端
      window.location.href = "http://fudaicy.com:8081";
    } else {
      // pc端
      window.location.href = "http://fudaicy.com:8080";
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
}


</script>

<style>

#app {
  padding: 0;
  margin: 0;
  background-color: white;
  font-size: 10px;
  /*width: 1920px;*/
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue